// Lets a shopper search or browse for a different product and swap it into one column of
// the comparison table, instead of only seeing the product the merchant originally picked.
document.querySelectorAll('comparison-table').forEach(function (table) {
  var searchUrl = table.dataset.predictiveSearchUrl;
  var sectionId = table.dataset.sectionId;
  var resultsPanel = document.getElementById('ComparisonSearchResults-' + sectionId);
  if (!searchUrl || !resultsPanel) return;

  var activeColumnIndex = null;
  var debounceTimer = null;
  var openSwapWrapper = null;
  var trackingFrame = null;

  // Updates one column (image, title, buttons, and the comparison rows) to show the
  // product the shopper just picked from search or browse.
  function swapColumn(columnIndex, product) {
    var productCell = table.querySelector(
      '[data-comparison-table-product-cell][data-column-index="' + columnIndex + '"]'
    );
    if (productCell) {
      var imageWrapper = productCell.querySelector('[data-comparison-table-image]');
      if (imageWrapper) {
        imageWrapper.innerHTML = product.image
          ? '<img src="' + product.image + '" alt="' + product.title + '" class="motion-reduce hover-scale-up" loading="lazy">'
          : '';
      }

      var titleText = productCell.querySelector('[data-comparison-table-title]');
      if (titleText) titleText.textContent = product.title;

      var titleLink = productCell.querySelector('[data-comparison-table-title-link]');
      if (titleLink) titleLink.href = product.url;

      // The Shop button is commented out in the section for now. Keeping this update here
      // means it will already work correctly if it gets turned back on later.
      var shopLink = productCell.querySelector('[data-comparison-table-shop-link]');
      if (shopLink) shopLink.href = product.url;

      var isAvailable = product.available === 'true';

      var variantInput = productCell.querySelector('[data-comparison-table-variant-input]');
      if (variantInput) variantInput.value = product.variant_id;

      var addToCartButton = productCell.querySelector('[data-comparison-table-add-to-cart]');
      if (addToCartButton) addToCartButton.disabled = !isAvailable;

      var addToCartText = productCell.querySelector('[data-comparison-table-add-to-cart-text]');
      if (addToCartText) addToCartText.textContent = isAvailable ? 'Add to Cart' : 'Sold Out';
    }

    var rowCells = table.querySelectorAll(
      '[data-comparison-table-row-cell][data-column-index="' + columnIndex + '"][data-metafield-key]'
    );
    rowCells.forEach(function (cell) {
      var rowKey = cell.dataset.metafieldKey;
      var value = product[rowKey];

      // Not every product has these filled in. Without a fallback the cell was
      // simply wiped, which is what made the table look broken after a swap.
      // Description borrows the product's own description instead, and the other
      // two say N/A so the row still reads as deliberate.
      if (!value) {
        if (rowKey === 'compare_description') {
          value = product.description || 'N/A';
        } else {
          value = 'N/A';
        }
      }

      // innerHTML rather than textContent because this content is rich text, the
      // same as what Liquid writes into these cells on first load. Using
      // textContent showed the raw paragraph tags on screen.
      var textWrapper = cell.querySelector('[data-comparison-table-row-text]');
      var target = textWrapper || cell;
      target.innerHTML = value;
    });
  }

  // Closes the results box and stops it from following the search field around.
  function hideResults() {
    resultsPanel.classList.add('hidden');
    openSwapWrapper = null;
    if (trackingFrame) cancelAnimationFrame(trackingFrame);
    trackingFrame = null;
  }

  // Moves the results box to sit just under the given search field, then pulls it
  // back if it would hang off either side of the screen. Without this, a column
  // near the right edge pushed the box off-screen where it could not be read.
  function positionResultsUnder(swapWrapper) {
    var fieldRect = swapWrapper.getBoundingClientRect();

    // clientWidth leaves the scrollbar out, unlike window.innerWidth which counts
    // it as usable space and lets the box slide underneath it.
    var viewportWidth = document.documentElement.clientWidth;

    // Hand the usable width to the CSS so the box is measured against the same
    // number the clamp below uses, scrollbar excluded.
    resultsPanel.style.setProperty('--comparison-results-available-width', viewportWidth * 0.95 + 'px');

    // The other half of that 95%, so there is a matching gap at each edge.
    var edgeGap = viewportWidth * 0.025;
    var panelWidth = resultsPanel.offsetWidth;

    // Line up with the search field first, then clamp to the screen.
    var left = fieldRect.left;
    var furthestRight = viewportWidth - panelWidth - edgeGap;

    if (left > furthestRight) {
      left = furthestRight;
    }
    if (left < edgeGap) {
      left = edgeGap;
    }

    resultsPanel.style.top = fieldRect.bottom + 4 + 'px';
    resultsPanel.style.left = left + 'px';
  }

  // Keeps the results box lined up with its search field while the page scrolls.
  function trackPosition() {
    if (!openSwapWrapper) return;
    positionResultsUnder(openSwapWrapper);
    trackingFrame = requestAnimationFrame(trackPosition);
  }

  // Shows the results box under the given search field. It lives at the end of the page
  // (not inside the table) so it always displays fully and on top of everything else.
  function showResultsUnder(swapWrapper) {
    document.body.appendChild(resultsPanel);
    openSwapWrapper = swapWrapper;
    resultsPanel.classList.remove('hidden');
    trackPosition();
  }

  // Fetches a fresh copy of the results box's contents and shows it.
  function renderResultsFrom(url, swapWrapper) {
    fetch(url)
      .then(function (response) {
        return response.text();
      })
      .then(function (responseText) {
        var parsedDoc = new DOMParser().parseFromString(responseText, 'text/html');
        var freshResults = parsedDoc.getElementById('ComparisonSearchResults-' + sectionId);
        if (freshResults) resultsPanel.innerHTML = freshResults.innerHTML;
        showResultsUnder(swapWrapper);
      });
  }

  // Looks up products matching whatever the shopper typed.
  function fetchSearchResults(query, swapWrapper) {
    var url = new URL(searchUrl, window.location.origin);
    url.searchParams.set('q', query);
    url.searchParams.set('resources[type]', 'product');
    url.searchParams.set('resources[limit]', 5);
    url.searchParams.set('resources[limit_scope]', 'each');
    url.searchParams.set('section_id', sectionId);
    renderResultsFrom(url, swapWrapper);
  }

  // Loads every product to browse, for when the shopper doesn't type a search at all.
  function fetchBrowseResults(swapWrapper) {
    var url = new URL(window.location.pathname, window.location.origin);
    url.searchParams.set('section_id', sectionId);
    renderResultsFrom(url, swapWrapper);
  }

  table.querySelectorAll('[data-comparison-table-swap]').forEach(function (input) {
    // Clicking into the field opens results right away, either the browse list or a
    // search already in progress.
    input.addEventListener('focus', function () {
      activeColumnIndex = input.dataset.columnIndex;
      var swapWrapper = input.closest('.comparison-table__product-swap');
      var query = input.value.trim();

      if (query.length === 0) {
        fetchBrowseResults(swapWrapper);
      } else {
        fetchSearchResults(query, swapWrapper);
      }
    });

    // Waits briefly after typing stops before searching, so it doesn't search on every
    // single keystroke.
    input.addEventListener('input', function () {
      activeColumnIndex = input.dataset.columnIndex;
      var query = input.value.trim();
      var swapWrapper = input.closest('.comparison-table__product-swap');

      clearTimeout(debounceTimer);
      if (query.length === 0) {
        fetchBrowseResults(swapWrapper);
        return;
      }
      debounceTimer = setTimeout(function () {
        fetchSearchResults(query, swapWrapper);
      }, 300);
    });
  });

  // The down-arrow button opens the browse list, or closes it again if it's already open.
  table.querySelectorAll('[data-comparison-table-browse]').forEach(function (browseButton) {
    browseButton.addEventListener('click', function () {
      var swapWrapper = browseButton.closest('.comparison-table__product-swap');
      var isOpenForThisColumn = !resultsPanel.classList.contains('hidden') && openSwapWrapper === swapWrapper;

      if (isOpenForThisColumn) {
        hideResults();
        return;
      }

      activeColumnIndex = browseButton.dataset.columnIndex;
      fetchBrowseResults(swapWrapper);
    });
  });

  // Picking a product from the results swaps it into the column and closes the list.
  resultsPanel.addEventListener('click', function (event) {
    var resultButton = event.target.closest('[data-title]');
    if (!resultButton || activeColumnIndex === null) return;

    swapColumn(activeColumnIndex, {
      title: resultButton.dataset.title,
      url: resultButton.dataset.url,
      image: resultButton.dataset.image,
      variant_id: resultButton.dataset.variant_id,
      available: resultButton.dataset.available,
      compare_description: resultButton.dataset.compare_description,
      compare_function: resultButton.dataset.compare_function,
      compare_recommendation: resultButton.dataset.compare_recommendation,
      description: resultButton.dataset.description,
    });
    hideResults();
  });

  // Clicking anywhere else on the page closes the results box.
  document.addEventListener('click', function (event) {
    var clickedInsideField = event.target.closest('.comparison-table__product-swap');
    var clickedInsideResults = resultsPanel.contains(event.target);
    if (!clickedInsideField && !clickedInsideResults) hideResults();
  });
});
